export default "__VITE_ASSET__B7YJ_mxc__"